export enum BizboxUserDepartment {
  NotApplicable = 0,
  Owner = 1,
  FinanceManagement = 2,
  HelpdeskSpecialist = 3,
  Developer = 4,
  QualityAssurance = 5,
  AccountManager = 6,
  KRA = 7,
  ProjectManager = 8,
  BusinessAnalyst = 9,
}

export const bizboxUserDepartmentOptions = [
  { label: "Not Applicable", value: BizboxUserDepartment.NotApplicable },
  { label: "Owner", value: BizboxUserDepartment.Owner },
  { label: "Finance Management", value: BizboxUserDepartment.FinanceManagement },
  { label: "Helpdesk Specialist", value: BizboxUserDepartment.HelpdeskSpecialist },
  { label: "Developer", value: BizboxUserDepartment.Developer },
  { label: "Quality Assurance", value: BizboxUserDepartment.QualityAssurance },
  { label: "Account Manager", value: BizboxUserDepartment.AccountManager },
  { label: "KRA", value: BizboxUserDepartment.KRA },
  { label: "Project Manager", value: BizboxUserDepartment.ProjectManager },
  { label: "Business Analyst", value: BizboxUserDepartment.BusinessAnalyst },
];

export const getBizboxUserDepartmentLabel = (value: number | null | undefined): string => {
  const option = bizboxUserDepartmentOptions.find((o) => o.value === value);
  return option?.label ?? "Not Applicable";
};
